<div class="flex flex-col items-center overflow-clip rounded-2xl bg-gray-000">
	<div role="tablist" aria-label="بخش‌های نماد" class="flex w-full items-center justify-center gap-2 p-2">
		@for (tab of tabs(); track tab.id) {
			@let active = activeTab() === tab.id;
			@let icon = active ? (tab.activeIcon ?? tab.icon) : tab.icon;
			@let opensSheet = tab.id === 'more';
			<button
				type="button"
				role="tab"
				class="flex min-w-0 flex-1 cursor-pointer flex-col items-center justify-center gap-1 rounded-2xl focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
				[class.text-gray-600]="!active"
				[class.text-gray-900]="active"
				[id]="'symbol-detail-tab-' + tab.id"
				[attr.data-cy]="'symbol-detail-tab-' + tab.id"
				[attr.aria-controls]="opensSheet ? null : 'symbol-detail-panel-' + tab.id"
				[attr.aria-haspopup]="opensSheet ? 'dialog' : null"
				[attr.aria-selected]="active"
				(click)="onTabClick(tab)">
				<span
					class="flex w-full items-center justify-center rounded-full border border-solid px-4 py-1.5 transition-colors duration-200 ease-in-out"
					[class.border-stroke-050]="!active"
					[class.border-gray-800]="active"
					[class.bg-gray-050]="active">
					<ui-icon width="20" height="20" aria-hidden="true" [iconName]="icon" />
				</span>
				<span class="flex h-4.5 items-center justify-center text-xs font-medium whitespace-nowrap">
					{{ tab.label }}
				</span>
			</button>
		}
	</div>
</div>
